import { Alert } from "componentsv2/widgets/Alert";
import { InfoIcon } from "components/Icons";

function MelhousNotice({ text }) {
  return (
    <Alert
      text={text}
      show={true}
      color="bg-sky-50 text-sky-900 border border-sky-200"
      className="!pr-4 !shadow-none text-sm"
    >
      <InfoIcon width={20} className="shrink-0 fill-current" />
    </Alert>
  );
}

export default MelhousNotice;
